export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.8846cb04.worker.js");
}
